import React from 'react';
import { MapPin, Phone, Mail, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-stone-800 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white text-xl font-serif mb-4">Villa Nomade</h3>
            <p className="text-sm leading-relaxed mb-4">
              Une villa d'exception aux Portes en Ré, entre golf, plages et marais salants. 
              Profitez d'un séjour inoubliable sur l'île de Ré.
            </p>
            <p className="text-xs text-amber-500">
              Référencement N°17286 000168 PF
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-xl font-serif mb-4">Liens Rapides</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-amber-500 transition-colors duration-300">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/photos" className="hover:text-amber-500 transition-colors duration-300">
                  Album Photos
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="hover:text-amber-500 transition-colors duration-300">
                  Réservation & Tarifs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-amber-500 transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/livre-dor" className="hover:text-amber-500 transition-colors duration-300">
                  Livre d'Or
                </Link>
              </li>
              <li>
                <Link to="/ile-de-re" className="hover:text-amber-500 transition-colors duration-300">
                  Découvrir l'Île de Ré
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-xl font-serif mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span>Les Portes en Ré<br />17880 Île de Ré, France</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0" />
                <span>+33 6 12 97 55 64</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0" />
                <a href="mailto:pouletbernard@neuf.fr" className="hover:text-amber-500 transition-colors">pouletbernard@neuf.fr</a>
              </li>
            </ul>
            <div className="flex flex-wrap items-center gap-3 mt-4">
              <a
                href="https://facebook.com/bernard.poulet.1671"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Notre page Facebook"
                className="bg-stone-700 p-2 rounded-full hover:bg-amber-700 transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=https://www.villa-nomade-ile-de-re.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#1877F2] hover:bg-[#166fe0] text-white text-sm font-medium px-4 py-2 rounded-full transition-colors duration-300"
              >
                <Facebook className="w-4 h-4" />
                Partager sur Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-700 mt-8 pt-8 text-center text-sm">
          <p>© {new Date().getFullYear()} Villa Nomade Les Portes en Ré. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;